export enum SupplierInvoiceStatusEnum {
  DRAFT = "DRAFT",
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
  CONFIRMED = "CONFIRMED",
}

export const getSupplierInvoiceStatusLabel = (status: SupplierInvoiceStatusEnum): string => {
  switch (status) {
    case SupplierInvoiceStatusEnum.DRAFT:
      return "BORRADOR";
    case SupplierInvoiceStatusEnum.READY_FOR_REVIEW:
      return "LISTO PARA REVISIÓN";
    case SupplierInvoiceStatusEnum.CONFIRMED:
      return "CONFIRMADO";
  }
};

export const getSupplierInvoiceStatusActionLabel = (status: SupplierInvoiceStatusEnum): string => {
  switch (status) {
    case SupplierInvoiceStatusEnum.READY_FOR_REVIEW:
      return "Marcar como listo para revisión";
    case SupplierInvoiceStatusEnum.CONFIRMED:
      return "Confirmar factura";
    case SupplierInvoiceStatusEnum.DRAFT:
      return "Devolver a borrador";
  }
};

export const getSupplierInvoiceStatusOptions = (): { label: string; value: string }[] =>
  Object.keys(SupplierInvoiceStatusEnum).map((val) => {
    const value = SupplierInvoiceStatusEnum[val as keyof typeof SupplierInvoiceStatusEnum];
    return { label: getSupplierInvoiceStatusLabel(value), value: value, translate: true };
  });

export function getSupplierInvoiceNextStatus(status: SupplierInvoiceStatusEnum): SupplierInvoiceStatusEnum {
  switch (status) {
    case SupplierInvoiceStatusEnum.DRAFT:
      return SupplierInvoiceStatusEnum.READY_FOR_REVIEW;
    case SupplierInvoiceStatusEnum.READY_FOR_REVIEW:
      return SupplierInvoiceStatusEnum.CONFIRMED;
    case SupplierInvoiceStatusEnum.CONFIRMED:
      return SupplierInvoiceStatusEnum.DRAFT;
  }
}
